import { appSession, opsSession, orgSession } from "../firebase";
import { createAuthStore } from "./create-auth-store";

export type { AuthState } from "./create-auth-store";

/**
 * The `/app` session, also used by `/`, `/invite/$code` and `/platform`. Runs on
 * the DEFAULT Firebase app, so every session persisted before the operations
 * split keeps working untouched.
 */
export const authStore = createAuthStore(appSession);

/**
 * The operations session, for `/operations` only. A genuinely separate login
 * with its own Firebase app and persistence namespace, so one user can be an
 * admin here and a different user in `/app` at the same time, in two tabs, and
 * signing out of either leaves the other alone.
 */
export const opsAuthStore = createAuthStore(opsSession);

/**
 * The organization session, for `/organization` only (TECH-3200). Separate from
 * the `/app` session for the same reason as operations, and more sharply so. Its
 * audience is a customer's own administrators, who usually also participate in a
 * workspace in that tenant. One session would make "administering my
 * organization" and "working in it" the same login.
 */
export const orgAuthStore = createAuthStore(orgSession);
